import React from 'react';
import styled from 'styled-components';
import theme from '^/theme';

interface RequestCountBadgeProps {
  count: number;
  testId?: string;
  isPrimary?: boolean;
}

const Badge = styled.div<{ isPrimary?: boolean }>(({ isPrimary }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: isPrimary ? theme.colors.lightBlue[500] : theme.colors.coolGray[75],
  padding: '2px 4px',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: 700,
  color: isPrimary ? theme.colors.white[100] : theme.colorTokens.textCoolDark,
}));

export const RequestCountBadge: React.FC<RequestCountBadgeProps> = ({
  count,
  testId,
  isPrimary,
}) => (
  <Badge data-testid={testId} isPrimary={isPrimary}>
    {count}
  </Badge>
);

export default RequestCountBadge;
